"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _SideClicks = _interopRequireDefault(require("./SideClicks"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    flex: 1,
    borderWidth: 0
  }, _reactNative.Platform.OS === 'web' ? {
    overflowX: 'hidden'
  } : {}),
  contentContainerStyle: {
    borderWidth: 0
  }
});

var List = function List(_ref, ref) {
  var _ref$onIndexChange = _ref.onIndexChange,
      onIndexChange = _ref$onIndexChange === void 0 ? function () {} : _ref$onIndexChange,
      exercices = _ref.exercices,
      itemWidth = _ref.itemWidth,
      itemHeight = _ref.itemHeight,
      renderItem = _ref.renderItem,
      animatedScroll = _ref.animatedScroll,
      _ref$disableNavigatio = _ref.disableNavigation,
      disableNavigation = _ref$disableNavigatio === void 0 ? false : _ref$disableNavigatio;
  var listRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      draggingEnabled = _useState2[0],
      setDraggingEnabled = _useState2[1];

  var _useState3 = (0, _react.useState)({
    list: [],
    currentIndex: null,
    currentScrollIndex: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      currentListObject = _useState4[0],
      setCurrentListObject = _useState4[1];

  var scrollTo = function scrollTo(params) {
    var reference = null;

    if (!listRef || !listRef.current) {
      return;
    }

    reference = listRef.current;

    if (!reference.scrollTo) {
      reference = reference.getNode();

      if (!reference.scrollTo) {
        return;
      }
    }

    reference.scrollTo(params);
  };

  var goToSide = function goToSide(side) {
    if (!draggingEnabled) {
      return false;
    }

    setDraggingEnabled(false);
    var rightIndex = currentListObject.currentScrollIndex + (currentListObject.currentScrollIndex === currentListObject.list.length - 1 ? 0 : 1);
    var leftIndex = currentListObject.currentScrollIndex + (currentListObject.currentScrollIndex === 0 ? 0 : -1);
    var index = side === 'left' ? leftIndex : rightIndex;
    var newCurrentListIndex = currentListObject.currentIndex + index - currentListObject.currentScrollIndex;

    if (newCurrentListIndex === currentListObject.currentIndex) {
      setDraggingEnabled(true);
      return false;
    }

    if (listRef && listRef.current) {
      if (_reactNative.Platform.OS === 'web') {
        setCurrentListIndex(newCurrentListIndex);
      } else {
        scrollTo({
          x: index * itemWidth,
          y: 0,
          animated: true
        });
      }
    }
  };

  var goToNext = function goToNext() {
    return goToSide('right');
  };

  var goToPrev = function goToPrev() {
    return goToSide('left');
  };

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      next: goToNext,
      prev: goToPrev
    };
  });

  var setCurrentListIndex = function setCurrentListIndex(index) {
    if (index === currentListObject.currentIndex) {
      setDraggingEnabled(true);
      return false;
    }

    var newIndex = index;

    if (newIndex < 0 || newIndex > exercices.length - 1) {
      newIndex = 0;
    }

    var list = [];
    var start = false;

    if (newIndex - 1 >= 0) {
      list.push(exercices[newIndex - 1]);
    } else {
      start = true;
    }

    list.push(exercices[newIndex]);

    if (newIndex + 1 < exercices.length) {
      list.push(exercices[newIndex + 1]);
    }

    setCurrentListObject({
      list: list,
      currentIndex: newIndex,
      currentScrollIndex: start ? 0 : 1
    });
    setDraggingEnabled(true);
    onIndexChange(newIndex);
  };

  (0, _react.useEffect)(function () {
    setCurrentListIndex(0); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // AFTER SCROLL => Change currentListObject.currentScrollIndex to be on the right position within the new list

  (0, _react.useEffect)(function () {
    if (currentListObject.list.length === 0) {
      return;
    }

    scrollTo({
      x: currentListObject.currentScrollIndex * itemWidth,
      y: 0,
      animated: false
    });
  }, [currentListObject, itemWidth]);

  var scrollEvent = function scrollEvent() {};

  if (animatedScroll) {
    scrollEvent = _reactNative.Animated.event([{
      nativeEvent: {
        contentOffset: {
          x: animatedScroll
        }
      }
    }], {
      useNativeDriver: false
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_reactNative.Animated.ScrollView, {
    scrollEventThrottle: 16,
    onScroll: scrollEvent,
    onMomentumScrollEnd: function onMomentumScrollEnd(event) {
      var currentPosition = event.nativeEvent.contentOffset.x;
      var index = currentPosition / itemWidth;

      if (index === Math.round(index)) {
        setDraggingEnabled(false);
        setCurrentListIndex(currentListObject.currentIndex + index - currentListObject.currentScrollIndex);
      }
    },
    onScrollEndDrag: function onScrollEndDrag(event) {
      var currentPosition = event.nativeEvent.contentOffset.x;
      var index = currentPosition / itemWidth;

      if (index === Math.round(index)) {
        setDraggingEnabled(false);
      }
    },
    scrollEnabled: !disableNavigation && _reactNative.Platform.OS !== "web" && draggingEnabled,
    ref: listRef,
    horizontal: true,
    snapToInterval: itemWidth,
    decelerationRate: "fast",
    pagingEnabled: true,
    style: styles.container,
    contentContainerStyle: styles.contentContainerStyle,
    showsHorizontalScrollIndicator: false
  }, currentListObject.list.map(function (item, index) {
    var itemIndex = currentListObject.currentIndex + index - currentListObject.currentScrollIndex;
    var isActive = itemIndex === currentListObject.currentIndex;
    return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
      key: (item && item.title) + "_" + index,
      style: {
        width: itemWidth,
        height: itemHeight
      }
    }, !disableNavigation && index > 0 && /*#__PURE__*/_react["default"].createElement(_SideClicks["default"], {
      position: "left",
      onPress: function onPress() {
        goToPrev();
      }
    }), !disableNavigation && index < currentListObject.list.length - 1 && /*#__PURE__*/_react["default"].createElement(_SideClicks["default"], {
      position: "right",
      onPress: function onPress() {
        goToNext();
      }
    }), renderItem(item, index, itemWidth, itemIndex, isActive));
  }));
};

var _default = /*#__PURE__*/_react["default"].forwardRef(List);

exports["default"] = _default;